<template>

    

  
  <div class="modal fade modal-xl" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
      
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{ title }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="row modal-body">
          <div class="col-md-12">
              <div>
        <a
      v-for="pimg in project_img"
      :key="pimg"
      :data-fancybox="'gallery'"
      :href="require(`@/${pimg}`)"
    >
      <img :src="require(`@/${pimg}`)" alt="Image" width="50" height="50"/>
    </a>
</div>
          </div>

          <div class="col-md-12">
            <h4 class="text-4 fw-600" v-if="pdescription">Project Info:</h4>
            <p v-html="pdescription"></p>
            <ul class="list-style-2">
              <li>
                <span class="text-dark fw-600 me-2">Date:</span>{{ prdate }}
              </li>
              <li  v-if=purl>
                <span class="text-dark fw-600 me-2">URL:</span><a
                  class="btn btn-primary shadow-none rounded-0 px-3 py-1" :href="purl" target="_blank">Click Here! <i
                    class="fas fa-external-link-alt ms-1"></i></a>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Fancybox } from '@fancyapps/ui'
import '@fancyapps/ui/dist/fancybox/fancybox.css'

Fancybox.bind('[data-fancybox="gallery"]')

export default {
  name: "model_popup",
  props: {
    title: String,
    project_img: Array,
    pdescription: String,
    prdate: Date,
    purl:URL
  },
};

</script>

<style>
.carousel .item>img {
  position: absolute;
  top: 0;
  left: 0;
  max-width: 100%;
  height: 100%;
}
</style>